import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "empty-notification-board",
	templateUrl: "./empty-notification-board.component.html",
	styleUrls: ["./empty-notification-board.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EmptyNotificationBoardComponent {}
